import { VF_PARAGRAPH } from 'AppSrc/core/components/forms/form-base-components/v-f-paragraph';

const fieldId = 'corrective-action-owner';

const validator = () => null;

const vFParams = {
  paragraph: 'Who is the owner of this corrective action?',
};

const correctiveActionOwner = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_PARAGRAPH,
};

export { correctiveActionOwner };
